import "../lib/stubs";

import _Sparkle from "./Sparkle";

const Sparkle = new _Sparkle(window.Sparkle);

window.Sparkle = Sparkle;
Sparkle._flushQueue();

export { Sparkle };
